import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBannersContent } from '../../Apis/index';

export const BannerContent = createAsyncThunk('bannercontent', async (formData, { rejectWithValue }) => {
    try {
        const response = await getBannersContent(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const bannercontentSlice = createSlice({
    name: 'bannercontent',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearBannerContentStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(BannerContent.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(BannerContent.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(BannerContent.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearBannerContentStatus } = bannercontentSlice.actions;
export default bannercontentSlice.reducer;

